import { render, staticRenderFns } from "./download-center.vue?vue&type=template&id=6550539a&scoped=true";
import script from "./download-center.vue?vue&type=script&lang=js";
export * from "./download-center.vue?vue&type=script&lang=js";
import style0 from "./download-center.vue?vue&type=style&index=0&id=6550539a&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6550539a", null);
export default component.exports;